"use client";

import React, { useState } from "react";
import { Expand } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/festival_crowd_cups.png",
  alt: "Großveranstaltung mit nachhaltigen Mehrwegbechern",
  aspect: "aspect-[3/4]"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup_cleaning_facility.png",
  alt: "Professionelle Reinigungsanlage für Becher",
  aspect: "aspect-square"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/branded_cups_close_up.png",
  alt: "Individuell bedruckte Mehrwegbecher im Detail",
  aspect: "aspect-video"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/logistics_delivery_truck.png",
  alt: "Pünktliche Lieferung der Event-Becher",
  aspect: "aspect-[4/5]"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/outdoor_concert_sustainability.png",
  alt: "Nachhaltiges Open-Air Konzert in Kärnten",
  aspect: "aspect-[3/2]"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup_stack_warehouse.png",
  alt: "Lagerung und Bestandskontrolle",
  aspect: "aspect-square"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/eco_friendly_event_detail.png",
  alt: "Müllvermeidung durch Mehrwegsysteme",
  aspect: "aspect-[3/4]"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/transparent_plastic_cup.png",
  alt: "Hochwertige, transparente Kunststoffbecher",
  aspect: "aspect-video"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/sporting_event_cups.png",
  alt: "Einsatz bei regionalen Sportveranstaltungen",
  aspect: "aspect-[4/3]"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup_return_station.png",
  alt: "Einfache Rückgabe am Event-Stand",
  aspect: "aspect-[2/3]"
}];
function GalleryItem({
  image,
  index,
  onClick
}: {
  image: (typeof galleryImages)[0];
  index: number;
  onClick: (src: string, alt: string) => void;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "50px"
  });
  return <div data-section-id="222072" ref={ref} data-index={index} className={`break-inside-avoid mb-6 relative group cursor-pointer overflow-hidden rounded-3xl shadow-sm transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} onClick={() => onClick(image.src, image.alt)}>
      <div className={`relative w-full ${image.aspect}`}>
        <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none transition-opacity duration-500 group-hover:opacity-0" />
        
        {}
        <div className="absolute inset-0 bg-secondary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-[2px]">
          <div className="bg-background/95 text-primary p-3 rounded-full transform scale-50 group-hover:scale-100 transition-transform duration-300 shadow-lg">
            <Expand className="w-5 h-5" />
          </div>
        </div>
      </div>
    </div>;
}
export default function CapturingTheMoment() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<{
    src: string;
    alt: string;
  } | null>(null);
  const handleImageClick = (src: string, alt: string) => {
    setSelectedImage({
      src,
      alt
    });
    setLightboxOpen(true);
  };
  return <section id="eindrücke-unserer-arbeit" className="py-24 px-4 md:px-8 bg-background text-foreground relative overflow-hidden">
      {}
      
      

      {}
      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent className="max-w-[95vw] md:max-w-screen-xl bg-background/95 backdrop-blur-md border-none shadow-4xl p-0 flex items-center justify-center rounded-3xl overflow-hidden" showCloseButton={true}>
          <DialogTitle className="sr-only">Bildergalerie Vollbild</DialogTitle>
          <DialogDescription className="sr-only">
            {selectedImage?.alt || "Vergrößerte Ansicht des Galeriebildes"}
          </DialogDescription>
          
          {selectedImage && <div className="relative w-full h-full flex items-center justify-center p-4 md:p-12">
              <img src={selectedImage.src} alt={selectedImage.alt} className="max-w-full max-h-[85vh] object-contain rounded-2xl shadow-2xl" />
              <p className="absolute bottom-0 left-0 right-0 text-center text-foreground font-default font-medium text-sm pb-4 md:pb-8 drop-shadow-sm">
                {selectedImage.alt}
              </p>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}